import CryptoJS from 'crypto-js';

const encrypted = sessionStorage.getItem("user");
let user = "";
if(encrypted!=null){
const decrypted = CryptoJS.AES.decrypt(encrypted, process.env.REACT_APP_SECRET_KEY).toString(CryptoJS.enc.Utf8);
user = JSON.parse(decrypted);
}

export { user };